import { auth } from './auth';
import { apiStatus } from './apiStatus';
import { activation } from './activation';
import { inputAddress } from './inputAddress';
import { locationDetails } from './location';
import { idDetails } from './idDetails';
import { otp } from './otp';
import { packages } from './package';
import { clientInformation } from './clientInformation';
import { scheduleVisit } from './scheduleVisit';
import { payment } from './payment';
import { zendesk } from './zendesk';

export default {
  auth,
  apiStatus,
  activation,
  locationDetails,
  packages,
  clientInformation,
  inputAddress,
  idDetails,
  otp,
  scheduleVisit,
  payment,
  zendesk
};
